export default __webpack_public_path__ + "static/media/404-removebg-preview.c1e00bd4.png";